import { api } from '@/api/client'

export async function fetchOfficeHoursAccounts() {
  const data = await api.get('/office-hours/accounts')
  return data.accounts ?? []
}

export async function fetchBuildingOfficeHours(accountId) {
  const data = await api.get(`/office-hours/accounts/${accountId}/buildings`)
  return data.buildings ?? []
}

export function updateBuildingOfficeHours({ accountId, updates }) {
  return api.put(`/office-hours/accounts/${accountId}/buildings`, { updates })
}
